import script from "./MembersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MembersPage.vue?vue&type=script&setup=true&lang=js"

import "./MembersPage.vue?vue&type=style&index=0&id=2e5238a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5238a3"]])

export default __exports__